var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"qlash-loader",style:({'height': `${_vm.size}px`, 'width': `${_vm.size}px`})},[_vm._m(0),_c('div',{staticClass:"lds-roller",style:({'height': `${_vm.size}px`, 'width': `${_vm.size}px`})},[_c('div'),_c('div'),_c('div'),_c('div'),_c('div'),_c('div'),_c('div'),_c('div')])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logo"},[_c('img',{attrs:{"src":"/images/logo.svg","alt":""}})])
}]

export { render, staticRenderFns }